import { Box, Typography, Grid, Container } from "@mui/material";
import Slider from "react-slick";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { coachexp } from "../../assets";

const SlickSlider = Slider as unknown as React.FC<any>;

const services = [
  "Luxury Sales Mastery Coaching",
  "Brand & Sales Strategy Planning",
  "Sales Consulting for Real Estate & Multiple Industries",
  "Personal Branding & Visibility Enhancement",
  "AI Tech Implementation & Process Automation",
  "Creating Templates & SOPs",
  "Scripts & Workshops",
];

const images = [
  "https://dprstorage.b-cdn.net/RW/exhibit1.png",
  "https://dprstorage.b-cdn.net/RW/portinnerf1.png",
  coachexp,
];

const NextArrow = ({ onClick }: any) => (
  <Box
    onClick={onClick}
    sx={{
      position: "absolute",
      right: "-24px",
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 5,
      cursor: "pointer",

      background: "#ffffff", // ✅ white bg
      borderRadius: "50%",
      width: "30px",
      height: "30px",

      display: "flex",
      alignItems: "center",
      justifyContent: "center",

      boxShadow: "0 4px 15px rgba(0,0,0,0.2)",

      "&:hover": {
        transform: "translateY(-50%) scale(1.05)",
      },
    }}
  >
    <ArrowForwardIos sx={{ color: "#0f63a5", fontSize: 18 }} />
  </Box>
);

const PrevArrow = ({ onClick }: any) => (
  <Box
    onClick={onClick}
    sx={{
      position: "absolute",
      left: "-23px",
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 5,
      cursor: "pointer",

      background: "#ffffff",
      borderRadius: "50%",
      width: "30px",
      height: "30px",

      display: "flex",
      alignItems: "center",
      justifyContent: "center",

      boxShadow: "0 4px 15px rgba(0,0,0,0.2)",

      "&:hover": {
        transform: "translateY(-50%) scale(1.05)",
      },
    }}
  >
    <ArrowBackIos sx={{ color: "#0f63a5", fontSize: 18 }} />
  </Box>
);


const DeliverSection = () => {
  const settings = {
    dots: true, // ✅ ENABLE DOTS
    infinite: true,
    autoplay: true,
    speed: 800,
    autoplaySpeed: 3000,
    arrows: true, // ✅ ENABLE ARROWS
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <Box
      sx={{
        py: 12,
       
        background: "transparent",
        color: "#fff",
      }}
    >
      <Container maxWidth='lg'>

        {/* HEADING */}
        <Typography
        variant="h3"
          textAlign="center"
          sx={{

            // fontSize: { xs: "2rem", md: "3rem" },
            letterSpacing: "4px",
            mb: 8,
            color:'white'
          }}
        >
          WHAT WE DELIVER
        </Typography>

        <Grid container spacing={8} alignItems="center">

          {/* 🔥 LEFT SIDE - SLIDER */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                borderRadius: "20px",
                position: "relative",
                overflow: "visible", // ✅ IMPORTANT

                "& .slick-slide": {
                  display: "flex !important",
                },

                "& .slick-prev:before, & .slick-next:before": {
                  display: "none",
                },

                // ✅ DOTS
                "& .slick-dots": {
                  bottom: "-30px",
                },
                "& .slick-dots li button:before": {
                  color: "#ffffff",
                  fontSize: "12px",
                  opacity: 0.6,
                },
                "& .slick-dots li.slick-active button:before": {
                  color: "#ffffff",
                  opacity: 1,
                },
              }}
            >
              <SlickSlider {...settings}>
                {images.map((img, index) => (
                  <Box key={index}>
                    <Box
                      component="img"
                      src={img}
                      alt="slide"
                      sx={{
                        width: "100%",
                        height: { xs: "260px", md: "400px" },
                        objectFit: "cover",
                        display: "block",
                      }}
                    />
                  </Box>
                ))}
              </SlickSlider>
            </Box>
          </Grid>

          {/* 🔥 RIGHT SIDE - LIST */}
          <Grid item xs={12} md={6}>
            <Box>
              {services.map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 4,
                  }}
                >
                  <Box
                    sx={{
                      width: "30px",
                      height: "1px",
                      background: "#d4af37",
                      mr: 2,
                    }}
                  />

                  <Typography
                    sx={{
                      fontSize: { xs: "0.95rem", md: "1.1rem" },
                      color: "rgba(255,255,255,0.85)",
                    }}
                  >
                    {item}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default DeliverSection;